<template>
  <div class="wrap_datepicker">
    <label v-if="label"> {{ label }} </label>
    <DatePicker
        class="form-control border-input"
        v-model="value2"
        :range="range"
        :lang="lang"
        :type="type"
        :valueType="value_type"
        :confirm="confirm"
        :disabled-date="disabledDate"
        :disabled-time="disabledTime"
        :clearable="clearable"
        :label="label"
        :placeholder="placeholder"
        :confirmText="confirm_text"
        :disabled="disabled"
        :readonly="disabled"
        @input="change_input"
    />
  </div>

</template>

<script>
import DatePicker from 'vue2-datepicker'
import ruLocaleDatePicker from "vue2-datepicker/locale/ru";
import enLocaleDatePicker from "vue2-datepicker/locale/en";

enLocaleDatePicker.formatLocale.firstDayOfWeek = 1

const updateCalendars = DatePicker.CalendarRange.methods.updateCalendars;

DatePicker.CalendarRange.methods.updateCalendars = function (...args) {
  updateCalendars.apply(this, args);
  if (args.length === 1) {
    this.calendars = this.calendars.map((v) => {
      const next = new Date(v);
      next.setMonth(next.getMonth() - 1);
      return next;
    });
  }
};

export default {
  components: {
    DatePicker
  },
  props: {
    value: {
      type: [Object, String, Array, Number],
      default: ""
    },
    value_type: {
      type: String,
      default: () => "X",
    },
    confirm: {
      type: Boolean,
      default: () => true,
    },
    clearable: {
      type: Boolean,
      default: () => true,
    },
    type:{
      type: String,
      default: () => "datetime",
    },
    range: {
      type: Boolean,
      default: () => true,
    },
    label: {
      type: String,
      default: () => "",
    },
    placeholder: {
      type: String,
      default: () => "",
    },
    confirm_text: {
      type: String,
      default: () => "OK",
    },
    disabled_date:{
      type: Array,
      default: () => [],
    },
    disabled_time:{
      type: Date,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      value2: []
    }
  },
  computed: {
    lang(){
      return this.$root.language === 'ru' ? ruLocaleDatePicker : enLocaleDatePicker
    },
  },
  watch: {
    value () {
      this.value2 = JSON.parse(JSON.stringify(this.value))
    }
  },
  mounted () {
    this.value2 = JSON.parse(JSON.stringify(this.value))
  },
  methods: {
    disabledTime(time){
      if (this.disabled_time) return time < new Date(this.disabled_time);
    },
    isValidDate(dateString) {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      return regex.test(dateString) && !isNaN(new Date(dateString).getTime());
    },
    transformDates(arr) {
      return arr.map(item => {
        if (this.isValidDate(item)) {
          return new Date(item);
        }

        let date = new Date();

        if (item === 'now') {
          return date;
        }

        let [sign, value, unit] = item.split(' ');

        value = parseInt(value);

        if (unit === 'month' || unit === 'months') {
          date.setMonth(date.getMonth() + (sign === '+' ? value : -value));
        } else if (unit === 'day' || unit === 'days') {
          date.setDate(date.getDate() + (sign === '+' ? value : -value));
        }

        return date;
      });
    },
    disabledDate(date) {
      let [date_start, date_end] = this.transformDates(this.disabled_date)
      return date > new Date(date_end) || date < new Date(date_start);
    },
    change_input () {
      this.$emit('input', this.value2)
    },
  },

}
</script>

<style lang="scss" scoped>
  .wrap_datepicker{
    display: flex;
    flex-direction: column;
    label{
      margin: 0;
    }
    .form-control{
      width: 100%;
    }
  }

  .wrap_datepicker ::v-deep .mx-datepicker.disabled .mx-input-wrapper {
    background: #e3e3e3;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    cursor: not-allowed;
  }

  .wrap_datepicker ::v-deep .mx-datepicker.disabled .mx-input {
    background: #e3e3e3;
    border: none;
    color: #66615b;
    cursor: not-allowed;
  }

  .wrap_datepicker ::v-deep .mx-datepicker.disabled .mx-input::placeholder {
    color: #cfcfcf;
  }

  .wrap_datepicker ::v-deep .mx-datepicker.disabled .mx-icon-calendar {
    color: #bfbfbf;
    cursor: not-allowed;
  }

</style>
